// Optional app-wide defaults, set once at startup so callers (prompt2FA() today, possibly other
// entry points later) don't have to repeat authority/clientId/accessToken at every call site.
// A plain module-level singleton, same style as the activeModal one in stepUp/modal.ts.
export interface ZIdentityConfig {
  authority?: string
  clientId?: string
  /**
   * Called on every prompt2FA() that needs a token — never cached here. Most apps already have
   * an equivalent function backing a silent refresh (grant_type=refresh_token): "fresh" only
   * means "not expired", it does not imply interactive re-authentication.
   */
  getAccessToken?: () => string | Promise<string>
}

let currentConfig: ZIdentityConfig | undefined

/**
 * Sets (replacing, not merging with, any previous call) the SDK-wide defaults. Pass `null` to
 * clear them — e.g. between tests, or when an app wants to drop its defaults on logout.
 */
export function configureZIdentity(config: ZIdentityConfig | null): void {
  currentConfig = config ?? undefined
}

export function getZIdentityConfig(): ZIdentityConfig | undefined {
  return currentConfig
}
